import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom';
import OrderSummary from '../../components/BuyCredit/OrderSummary/OrderSummary';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import { formatWithoutCurrency } from '../../helpers/helperFunction';
import { PaymentFailure } from './PaymentFailure';
import PaymentSuccessful from './PaymentSuccessful';
import { reloadTopbar } from '../../store/actions/reduxAction';
import StripeMethod from '../../components/BuyCredit/StripeMethod/StripeMethod';
import CreditCalculator from './CreditCalculator';

const API_BASE_URL = config.urls.api_base_url;

const BuyCredit = () => {
  const dispatch = useDispatch();
  const { access_token, currency } = useSelector((state) => state.auth.user)

  const [paymentSelected, setPaymentSelected] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [paymentIsLoading, setPaymentIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertShow, setAlertShow] = useState(false);
  const [alertVariant, setAlertVariant] = useState('');
  const [topUpAmount, setAmount] = useState('');
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [failureModalShow, setFailureModalShow] = useState(false);

  const [amountAfterTax, setAmountAfterTax] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const saleTax = 0.06;

  const amounts = [50, 200, 500, 1000, 10000, 50000];

  const handleTextInput = (event) => {
    const value = event.target.value;

    // If the value is empty, set the amount to an empty string
    if (value === '') {
      setAmount('');
      return;
    }

    // Ensure only whole numbers are entered
    const regex = /^\d*$/;
    if (regex.test(value)) {
      const numberOutput = Number(value);
      setAmount(numberOutput);
    }
  };


  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    onStripeResponse(query);
  }, [location]);

  useEffect(() => {
    if (alertShow) {
      const timeout = setTimeout(() => {
        setAlertMessage('');
        setAlertShow(false);
        setAlertVariant('');
      }, config.notify_time);
      return () => clearTimeout(timeout);
    }
  }, [alertShow]);

  const removeQuery = () => {
    const { pathname } = location;
    window.history.replaceState(pathname, '', pathname);
  };

  const onStripeResponse = (query) => {
    const p_id = query.get('p_id');
    const cancel = query.get('c');

    if (p_id !== null) {
      setPaymentIsLoading(true);

      const data = {};

      if (cancel) {
        data.cancel = true;
      }

      axios
        .put(`${API_BASE_URL}/payment/${p_id}/complete`, data, {
          headers: {
            Authorization: access_token.token,
          },
        })
        .then((res) => {
          const { error, message } = res.data;
          if (!error) {
            if (cancel) {
              onPaymentResponse(false, message);
            } else {
              onPaymentResponse(true, res.data.data);
              setSuccessModalShow(true);
              dispatch(reloadTopbar());
            }
          } else {
            onPaymentResponse(false, message);
            setFailureModalShow(true);
          }
        })
        .catch((err) => {
          setAlertMessage(
            'Something went wrong! Select credit package again and then click on payment button.'
          );
          setAlertShow(true);
          setAlertVariant('danger');
        });
    }
  };

  const onPaymentResponse = (status, data) => {
    setPaymentStatus(status);
    setPaymentSelected(true);
    setPaymentDetails(data);
    setPaymentIsLoading(false);
    removeQuery();
  };

  const paymentIsLoadingFunc = (status) => {
    setPaymentIsLoading(status);
  };

  return (
    <div className="BuyCredit">
      <PaymentSuccessful show={successModalShow} onHide={setSuccessModalShow} />
      <PaymentFailure show={failureModalShow} onHide={setFailureModalShow} />
      <CustomAlert
        message={alertMessage}
        show={alertShow}
        variant={alertVariant}
        closeAlert={() => {
          setAlertShow(false);
          setAlertVariant('');
          setAlertMessage('');
        }}
      />
      <div className="page-heading pb-2">
        <div className="container-left w-100">
          <div className="page-title">Top Up</div>
        </div>
        <p>Buy messaging credits to send messages</p>
      </div>
      <div className="bg-white" style={{ padding: '0 40px 40px' }}>
        <Row>
          <Col xs={12} xl={8}>
            <Form className="mb-3">
              <Form.Group controlId="topUpAmount">
                <Form.Label className="font-weight-bold">Enter Amount</Form.Label>
                <Form.Control
                  placeholder="Enter your top up amount"
                  value={topUpAmount}
                  onChange={handleTextInput}
                  type="number"
                />
              </Form.Group>
              <Form.Group className="d-flex gap-1 flex-wrap">
                {amounts.map((amount) => (
                  <Button
                    key={amount}
                    variant="multi-pick"
                    active={amount === topUpAmount}
                    className="rounded-pill credit-buttons"
                    onClick={() => setAmount(amount)}
                  >
                    {`${currency.symbol} ${formatWithoutCurrency(amount, 0)}`}
                  </Button>
                ))}
              </Form.Group>
            </Form>
            <p>
              By completing the purchase, I agree with elfoA2P{' '}
              <Link to="/terms-of-service" target="_blank">
                Terms of service
              </Link>{' '}
              and{' '}
              <Link to="/privacy-policy" target="_blank">
                Privacy policy
              </Link>
            </p>
            <div className="totalAmountBox">
              <StripeMethod
                symbol={currency ? currency : { symbol: '' }}
                amountBeforeTax={topUpAmount}
                amountAfterTax={amountAfterTax}
                accessToken={access_token?.token}
                paymentIsLoadingFlag={paymentIsLoadingFunc}
              />
            </div>
          </Col>
          <Col xs={12} xl={4}>
            <OrderSummary
              paymentIsLoading={paymentIsLoading}
              userDefaultCurrency={currency ? currency : { symbol: '' }}
              accessToken={access_token?.token}
              paymentIsLoadingFlag={paymentIsLoadingFunc}
              topUpAmount={topUpAmount}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <CreditCalculator />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BuyCredit
